<template>
  <v-container>
    <v-card class="elevation-3 mt-3">
      <v-container class="pt-0">
        <v-layout row wrap>
          <v-flex xs12>
            <v-toolbar color="white" text class="mt-0 pt-0 elevation-0">
              <v-toolbar-title class="subtitle-1 font-weight-medium">
                Novo Hospital
              </v-toolbar-title>
            </v-toolbar>
          </v-flex>

          <v-flex xs8>
            <v-card-text>
              <FormHospitalInfo ref="formHospital" />
            </v-card-text>
          </v-flex>

          <v-flex xs8>
            <v-card-text>
              <FormContactInfo ref="formContact" />
            </v-card-text>
          </v-flex>

          <v-flex xs12 class="pl-12">
            <v-btn
              class="body-2 white--text"
              @click="newHospital"
              color="primary"
              depressed
              :loading="loading"
            >
              Adicionar Hospital
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import FormHospitalInfo from "../../../components/admin/hospital/FormHospitalInfo";
import FormContactInfo from "../../../components/admin/hospital/FormContactInfo";
import moment from 'moment'
export default {
  name: "NewHospital",
  components: {
    FormHospitalInfo,
    FormContactInfo
  },
  data: () => ({
    loading:false
  }),
  methods: {
    newHospital() {
      let formHospital = this.$refs.formHospital.setHospitalInfo();
      let formContact = this.$refs.formContact.setContactInfo();
      if (formContact && formHospital) {
        this.loading = true;
        let obj = {
          id: this.id,
          ...formHospital,
          contact: { ...formContact },
          date: moment().format("DD/MM/YYYY")
        };
        let enndereco =  obj.address.split(',')
        let address = {    
          "state": "Amazonas",
          "city": "Manaus",
          "street": enndereco[0]?enndereco[0]:'',
          "number": enndereco[1]?enndereco[1]:'',
          "neighborhood": enndereco[2]?enndereco[2]:'',
          "zipcode": enndereco[3]?enndereco[3]:'',
          "latitude": "0",
          "longitude": "0"
        };
        obj.address=address;
        this.$store.dispatch("addNewHospital", obj)
          .then( async ( response ) => {
            if (response.status){
              await this.$store.dispatch('loadHospitals');
            }else{
              //TODO: houve erro, criar msg pro usuário de resposta
            }
            console.log('addNewHospital',response);
            this.loading = false;
            this.$router.back();
          })
          .catch(error=>{
            //TODO: houve erro, criar msg pro usuário de resposta
            this.loading = false
          })
        
      }
    }
  }
};
</script>

<style>
</style>